"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrBrandLogo = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
const BrandImageLink = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)({
    height: '40px',
    textAlign: 'center',
    transition: 'fast',
    fontSize: 0,
    letterSpacing: 'initial',
}, ({ link, theme }) => (Object.assign({ '&:hover': link ? { borderColor: theme.colors.primary } : {} }, theme.brandLogos.imageLink)));
const BrandImage = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage)(({ theme }) => ({
    width: '100%',
    height: '100%',
    maxHeight: '40px',
    objectFit: 'contain',
    [theme.media.tablet]: {
        width: 'auto',
    },
}));
const FdrBrandLogo = ({ item, }) => {
    var _a;
    const caption = ((_a = item === null || item === void 0 ? void 0 : item.icon) === null || _a === void 0 ? void 0 : _a.description) || '';
    return (react_1.default.createElement(BrandImageLink, { link: item.link, className: "brand-link", testId: "brand-logo-link-id" },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(BrandImage, { className: "brand-image", image: item.icon, "data-id": "brand-logo-id" }),
            caption)));
};
exports.FdrBrandLogo = FdrBrandLogo;
//# sourceMappingURL=fdr-brand-logo.js.map